// tabs
$('.tab-link').click(function (e) {
  let self  =  $(this).parents('.js-tabs'),
      delay =  self.data('delay'),
      id    =  $(this).attr('href');

  self.find('li').removeClass('active');
  $(this).parent('li').addClass('active');
  self.find('.tab-block').removeClass('_tab-anim visible');

  setTimeout(function () {
    self.find('.tab-block').removeClass('active');
    $(id).addClass('active _tab-anim');
  }, delay);

  e.preventDefault();

});
